<figure class="player" [ngClass]="(showNavPlayer$ | push) ? 'mini' : 'maxi' ">
	<div class="control-buttons" [class]="(isPlayingMini$ | push) ? 'playing' : 'pause' " (click)="controlPlayer()" >
		<app-icon title="spustit video" class="control-button play" name="playCircle" [shadow]="false" ></app-icon>
		<app-icon title="zastavit video" class="control-button pause" name="pauseCircle" [shadow]="false" ></app-icon>
	</div>
	<a title="{{(playingVideoLink$ | push).label}}" class="back-to-video-btn link" [routerLink]="(playingVideoLink$ | push).url" (click)="scrollToTop()" >
		<div class="player-wrapper" *ngFor="let medium of (player$ | push)" >
			<app-player [medium]="medium" ></app-player>
		</div>	
	</a>
</figure>

<div class="screen-container"  >
	<div class="screen-slide" *ngFor="let item of (activeScreen$ | push)" [@backgroundAnimation] >
		<app-media 
			class="background-image" 
			kind="screen" 
			alt="{{item.entityLabel}}" 
			[src]="item.field_image_url" 
			loading="eager"
			[position]="item.field_image_position_1"
		></app-media>
	</div>
</div>


<nav class="ui-control" *ngIf="isBrowser" >
	<div class="play-button" [ngClass]="(showPlayBtn$ | push) ? 'show': 'hide' " *rxLet="activeItem$; let activeItem; strategy: strategy" (click)="playVideo(activeItem)" title="přehrát video" >
		<span class="mat-ripple-container" matRipple ></span>
		<app-icon class="play-button-icon" name="playCircle" [shadow]="true" ></app-icon>
	</div>

	<ul class="arrows">
	  <li 
	  	class="arrow prev" 
	  	*rxLet="prev$; let prev; strategy: strategy"
	  	[ngClass]="prev ? 'show': 'hide' "
	  	title="{{prev.title}}" 
	  >
	    <a class="route-link"  queryParamsHandling="merge" [routerLink]="prev ? prev.url :  ''" [queryParams]="prev.page === 1 ? {} : { strana: prev.page }" >
	    	
	    	<div class="button-container">
	    		<span class="mat-ripple-container" matRipple ></span>
	    		<app-icon class="arrow-icon" name="up" [shadow]="true" ></app-icon>
	    	</div>
	      
	    </a>
	  </li>
	  <li 
	  	class="arrow next" 
	  	*rxLet="next$; let next; strategy: strategy"
	  	[ngClass]="next ? 'show': 'hide' "
	  	title="{{next.title}}" 
	  > 
	    <a class="route-link"  queryParamsHandling="merge" [routerLink]="next ? next.url : ''" [queryParams]="next.page === 1 ? {} : { strana: next.page }" >
	    	
	      <div class="button-container">
	      	<span class="mat-ripple-container" matRipple ></span>
	    		<app-icon class="arrow-icon" name="up" [shadow]="true" ></app-icon>
	    	</div>
	    </a>
	  </li>
	</ul>
	
</nav>

